//全局自定义指令
const directives = {
  focus: {
    // 当被绑定的元素插入到DOM中时
    inserted: (el) => {
      // 聚焦元素
      el.focus()
    }
  },
  /*
       v-font="70"
      */
  font: {
    inserted: (el, binding) => {
      el.style.fontSize = `${binding.value}px`;
    },
  },
  position: {
    bind(el, binding) {
      const { value } = binding;
      const timer = setTimeout(() => {
        clearTimeout(timer);
        if (value) {
          const { id, parentClassName, type } = value;
          id && el.setAttribute('data-id', id);
          type && el.setAttribute('data-type', type);
          parentClassName && el.setAttribute('data-top', getElementTop(el, parentClassName));
        }
      }, 100);
    },
  },
  openUrl: {
    bind(el) {
      el.onclick = (e) => {
        if (e.target.tagName === 'A' && window.dfPcDesktop) {
          e.stopPropagation();
          const url = e.target.href;
          window.dfPcDesktop.openUrl(url);
        }
      };
    },
  }
};

function getElementTop(el, className) {
  let top = 0;
  while (el && !el.classList.contains(className)) {
    top += el.offsetTop;
    el = el.offsetParent;
  }
  return top;
}

export default function install(Vue) {
  Object.keys(directives).forEach((key) => {
    Vue.directive(key, directives[key]);
  });
}
